import React, { useState, useEffect } from 'react';
import { Row } from './Layout';
import { PageHeader } from './PageHeader';

const CATEGORIES = ["Tümü", "Gaming", "Müzik", "Sohbet", "Spor", "Sanat", "Tech", "Eğitim"];

interface GoLiveScreenProps {
    onClose: () => void;
    onStart: (data: { title: string; category: string; type: 'video' | 'voice' }) => void;
}

export const GoLiveScreen: React.FC<GoLiveScreenProps> = ({ onClose, onStart }) => {
    const [title, setTitle] = useState('');
    const [cat, setCat] = useState('Gaming');
    const [mode, setMode] = useState<'video' | 'audio'>('video');
    const [cd, setCd] = useState<number | null>(null);

    // Settings States
    const [visibility, setVisibility] = useState('Herkese açık');
    const [chatEnabled, setChatEnabled] = useState('Açık');
    const [giftsEnabled, setGiftsEnabled] = useState('Aktif');

    const toggleSetting = (type: string) => {
        if (type === 'viewer') setVisibility(v => v === 'Herkese açık' ? 'Sadece Takipçiler' : 'Herkese açık');
        if (type === 'chat') setChatEnabled(c => c === 'Açık' ? 'Kapalı' : 'Açık');
        if (type === 'gift') setGiftsEnabled(g => g === 'Aktif' ? 'Pasif' : 'Aktif');
    };

    const start = () => {
        setCd(3);
        const t = setInterval(() => setCd(c => {
            if (c !== null && c <= 1) {
                clearInterval(t);
                // Map audio to voice for the parent component to handle VoiceRooms correctly
                setTimeout(() => onStart({ title: title || `${cat} Yayını`, category: cat, type: mode === 'audio' ? 'voice' : 'video' }), 200);
                return 0;
            }
            return c !== null ? c - 1 : null;
        }), 1000);
    };

    if (cd !== null) return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 10000,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'radial-gradient(circle at center,#1a0a1a,#0A0A0F)', flexDirection: 'column', gap: 14
        }}>
            <div className="syne" style={{
                fontSize: 120, fontWeight: 800, lineHeight: 1,
                background: 'linear-gradient(135deg,var(--coral),var(--orange))',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                animation: 'heartbeat .7s ease infinite'
            }}>
                {cd || '🎬'}
            </div>
            <div style={{ color: 'var(--muted)', fontSize: 15 }}>Yayın başlıyor...</div>
        </div>
    );

    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 10000, height: '100%', display: 'flex', flexDirection: 'column', background: 'var(--bg)', animation: 'slideUp .45s cubic-bezier(.16,1,.3,1)' }}>
            <PageHeader title="Yayın Başlat" onBack={onClose} />
            <div style={{ flex: 1, overflowY: 'auto', padding: '0 18px', display: 'flex', flexDirection: 'column', gap: 16 }}>
                {/* Preview */}
                <div style={{
                    borderRadius: 20, overflow: 'hidden', height: 180, position: 'relative',
                    background: 'linear-gradient(135deg,#1a0a1a,#0d0d1a)', border: '1px solid var(--border)'
                }}>
                    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 9 }}>
                        <div style={{ width: 52, height: 52, borderRadius: 16, background: 'var(--surface2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>
                            {mode === 'video' ? '📷' : '🎙️'}
                        </div>
                        <span style={{ color: 'var(--muted)', fontSize: 12 }}>{mode === 'video' ? 'Kamera önizleme' : 'Ses modu aktif'}</span>
                    </div>
                    {mode === 'audio' && (
                        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                            {Array(9).fill(0).map((_, i) => (
                                <div key={i} style={{
                                    width: 4, borderRadius: 2,
                                    background: `linear-gradient(to top,var(--cyan),var(--purple))`,
                                    animation: `waveBar ${.5 + i * .07}s ease-in-out ${i * .05}s infinite`
                                }} />
                            ))}
                        </div>
                    )}
                </div>
                {/* Mode */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 9 }}>
                    {[{ id: 'video' as const, icon: '🎥', label: 'Video Yayın' }, { id: 'audio' as const, icon: '🎙️', label: 'Sesli Oda' }].map(m => (
                        <button key={m.id} onClick={() => setMode(m.id)} style={{
                            background: mode === m.id ? 'rgba(255,92,92,.15)' : 'var(--surface)',
                            border: `1px solid ${mode === m.id ? 'rgba(255,92,92,.4)' : 'var(--border)'}`,
                            borderRadius: 15, padding: '13px', cursor: 'pointer',
                            display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'center', transition: 'all .2s'
                        }}>
                            <span style={{ fontSize: 24 }}>{m.icon}</span>
                            <span className="syne" style={{ fontSize: 11, fontWeight: 700, color: mode === m.id ? 'var(--coral)' : 'var(--text)' }}>{m.label}</span>
                        </button>
                    ))}
                </div>
                {/* Title */}
                <div>
                    <div style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 6, fontWeight: 600, letterSpacing: '.07em' }}>YAYIN BAŞLIĞI</div>
                    <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Bugün ne yayınlıyorsun?"
                        style={{
                            width: '100%', background: 'var(--surface)', border: '1px solid var(--border)', boxSizing: 'border-box',
                            borderRadius: 12, padding: '11px 13px', color: 'var(--text)', fontFamily: 'DM Sans', fontSize: 13, outline: 'none'
                        }} />
                </div>
                {/* Category */}
                <div>
                    <div style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 6, fontWeight: 600, letterSpacing: '.07em' }}>KATEGORİ</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                        {CATEGORIES.slice(1).map(c => (
                            <button key={c} onClick={() => setCat(c)}
                                style={{
                                    background: c === cat ? 'rgba(255,92,92,.15)' : 'var(--surface2)',
                                    border: `1px solid ${c === cat ? 'rgba(255,92,92,.3)' : 'var(--border)'}`,
                                    borderRadius: 7, fontSize: 11, color: c === cat ? 'var(--coral)' : 'var(--muted)',
                                    padding: '4px 11px', cursor: 'pointer', transition: 'all .2s', fontFamily: 'DM Sans'
                                }}>
                                {c}
                            </button>
                        ))}
                    </div>
                </div>
                {/* Settings */}
                <div style={{ background: 'var(--surface)', borderRadius: 15, overflow: 'hidden', border: '1px solid var(--border)' }}>
                    {[
                        { id: 'viewer', icon: '👥', label: 'İzleyici', val: visibility },
                        { id: 'chat', icon: '💬', label: 'Sohbet', val: chatEnabled },
                        { id: 'gift', icon: '🎁', label: 'Hediyeler', val: giftsEnabled }
                    ].map((item, i) => (
                        <div key={i} onClick={() => toggleSetting(item.id)} style={{
                            display: 'flex', alignItems: 'center', padding: '11px 13px', cursor: 'pointer',
                            borderBottom: i < 2 ? '1px solid var(--border)' : 'none', justifyContent: 'space-between',
                            transition: 'background 0.2s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = 'var(--surface2)'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                            <Row style={{ gap: 8 }}>
                                <span style={{ fontSize: 16 }}>{item.icon}</span>
                                <span style={{ fontSize: 12 }}>{item.label}</span>
                            </Row>
                            <Row style={{ gap: 5 }}>
                                <span style={{ fontSize: 10, color: item.val === 'Kapalı' || item.val === 'Pasif' || item.val === 'Sadece Takipçiler' ? 'var(--coral)' : 'var(--cyan)' }}>
                                    {item.val}
                                </span>
                                <span style={{ color: 'var(--muted)', transform: 'rotate(90deg)' }}>↻</span>
                            </Row>
                        </div>
                    ))}
                </div>
            </div>
            <div style={{ padding: '13px 18px 36px', flexShrink: 0 }}>
                <button className="btn-primary" onClick={start}
                    style={{ width: '100%', padding: '14px', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9 }}>
                    <span className="dot-live" style={{ width: 8, height: 8 }} />Yayını Başlat
                </button>
            </div>
        </div>
    );
}
